/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GusClientDto
 */
export interface GusClientDto {
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    regon?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    nip?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    voivodeship?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    place?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    numbers?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    flat?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    postPlace?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    activityTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof GusClientDto
     */
    activityTypeShort?: string;
}

/**
 * Check if a given object implements the GusClientDto interface.
 */
export function instanceOfGusClientDto(value: object): value is GusClientDto {
    return true;
}

export function GusClientDtoFromJSON(json: any): GusClientDto {
    return GusClientDtoFromJSONTyped(json, false);
}

export function GusClientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GusClientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'regon': json['regon'] == null ? undefined : json['regon'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'name': json['name'] == null ? undefined : json['name'],
        'voivodeship': json['voivodeship'] == null ? undefined : json['voivodeship'],
        'place': json['place'] == null ? undefined : json['place'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'street': json['street'] == null ? undefined : json['street'],
        'numbers': json['numbers'] == null ? undefined : json['numbers'],
        'flat': json['flat'] == null ? undefined : json['flat'],
        'postPlace': json['postPlace'] == null ? undefined : json['postPlace'],
        'activityTypeId': json['activityTypeId'] == null ? undefined : json['activityTypeId'],
        'activityTypeShort': json['activityTypeShort'] == null ? undefined : json['activityTypeShort'],
    };
}

export function GusClientDtoToJSON(value?: GusClientDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'regon': value['regon'],
        'nip': value['nip'],
        'name': value['name'],
        'voivodeship': value['voivodeship'],
        'place': value['place'],
        'postcode': value['postcode'],
        'street': value['street'],
        'numbers': value['numbers'],
        'flat': value['flat'],
        'postPlace': value['postPlace'],
        'activityTypeId': value['activityTypeId'],
        'activityTypeShort': value['activityTypeShort'],
    };
}

